import React from "react";

export default function NotFound() {
  return <div>Page n'existe pas</div>;
}
